module.exports = __webpack_public_path__ + "static/media/logo.c76eac36.png";